import { FULL_PERCENT } from '@hooks/constants';
import { useQuery } from '@hooks/reactQuery';

import { getProgress } from '@api/configurationComparison';

import { handleErrorFromMessage } from '@utils/handleRequestError';

import { IResponseError } from '@interfaces/errors/apiErrors';
import { IProgressBranches } from '@interfaces/import/import';

import { MO_BRANCHES_PROGRESS } from '@constants/queryKeys';

interface IUseQueryProgressProps {
	progressId?: string;
	refetchIntervalProgress: number | false;
	setRefetchIntervalProgress: (v: number | false) => void;
}

export const useQueryProgress = (params: IUseQueryProgressProps) => {
	const {
		progressId,
		refetchIntervalProgress,
		setRefetchIntervalProgress,
	} = params || {};

	const { data: progress } = useQuery<IProgressBranches>({
		queryKey: [MO_BRANCHES_PROGRESS],
		queryFn: () => getProgress(progressId!),
		refetchInterval: refetchIntervalProgress,
		refetchOnWindowFocus: false,
		refetchOnmount: false,
		onSuccess: (data: IProgressBranches) => {
			if (data.percentsProgress !== null && Math.floor(data.percentsProgress) === FULL_PERCENT) {
				setRefetchIntervalProgress(false);
			}
		},
		enabled: [!!progressId],
		onError: (err: IResponseError) => {
			setRefetchIntervalProgress(false);
			handleErrorFromMessage(err);
		},
	});

	return { progress };
};
